import { Link } from '@blaze-cms/nextjs-components';
import { useInView } from '@blaze-react/utils/lib/customHooks';
import { FaFacebookF, FaPinterestP, FaInstagram, FaYoutube } from 'react-icons/fa';
import { IN_VIEW_CONFIG, PRIVACY } from '../../constants';

const Footer = () => {
  const [isIntersecting, outerRef] = useInView(IN_VIEW_CONFIG);

  const magazineCover =
    'https://cdn.boatinternational.com/convert/files/2023/08/24b43af0-3829-11ee-9bb9-93ddf0b9582a-BI_2023-_09SEP_HR.jpg/r%5Bwidth%5D=240/24b43af0-3829-11ee-9bb9-93ddf0b9582a-BI_2023-_09SEP_HR.jpg';

  return (
    <footer className="footer">
      <div className="footer__body">
        <div className="footer__box footer__box--left">
          <div className="footer__box-header">
            <Link href="/" className="footer__logo">
              <img className="footer__logo-image" src="/static/img/logo.png" alt="Boat logo" />
            </Link>
          </div>

          <div className="footer__box-content">
            <ul className="footer__menu-list">
              <li>
                <Link href="/advertising-media-kit" className="footer__menu-list-link">
                  Advertising & Media Kit
                </Link>
              </li>

              <li>
                <Link href="/about-us" className="footer__menu-list-link">
                  About Us
                </Link>
              </li>

              <li>
                <Link href="/contact" className="footer__menu-list-link">
                  Contact Us
                </Link>
              </li>

              <li>
                <Link href="/careers" className="footer__menu-list-link">
                  Careers
                </Link>
              </li>

              <li>
                <Link href="/terms-of-use" className="footer__menu-list-link">
                  Terms of Use
                </Link>
              </li>

              <li>
                <Link href="/cookie-policy" className="footer__menu-list-link">
                  Cookie Policy
                </Link>
              </li>

              <li>
                <Link href={PRIVACY.HREF} className="footer__menu-list-link">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__box">
          <div className="footer__box-header">More from BOAT International</div>

          <div className="footer__box-content footer__box-content--wrap">
            <ul className="footer__menu-list">
              <li>
                <Link href="/yachts" className="footer__menu-list-link">
                  Yachts
                </Link>
              </li>

              <li>
                <Link href="/yachts-for-sale" className="footer__menu-list-link">
                  Yachts For Sale
                </Link>
              </li>

              <li>
                <Link href="/charter" className="footer__menu-list-link">
                  Charter
                </Link>
              </li>

              <li>
                <Link href="/destinations" className="footer__menu-list-link">
                  Destinations
                </Link>
              </li>

              <li>
                <Link href="/luxury-yacht-life" className="footer__menu-list-link">
                  Boat Life
                </Link>
              </li>

              <li>
                <Link href="/boat-presents" className="footer__menu-list-link">
                  Boat Presents
                </Link>
              </li>

              <li>
                <Link href="/luxury-yacht-events" className="footer__menu-list-link">
                  Events
                </Link>
              </li>

              <li>
                <Link href="/boat-pro" className="footer__menu-list-link">
                  BOATPro
                </Link>
              </li>

              <li>
                <Link
                  href="https://shop.boatinternational.com/shop"
                  className="footer__menu-list-link">
                  Shop
                </Link>
              </li>

              <li>
                <Link href="/sitemap" className="footer__menu-list-link">
                  Site Map
                </Link>
              </li>

              <li>
                <Link href="https://bcreative.studio/" className="footer__menu-list-link">
                  bcreative.studio
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__box">
          <div className="footer__sub-box">
            <div className="footer__box-header">Follow us on</div>

            <div className="footer__sub-box-content">
              <ul className="footer__social">
                <li className="footer__social-item footer__social-item--facebook">
                  <a href="https://www.facebook.com/BoatInternational">
                    <i>
                      <FaFacebookF />
                    </i>
                  </a>
                </li>

                <li className="footer__social-item footer__social-item--twitter">
                  <a href="https://twitter.com/boatint">
                    <i>
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 0 512 512">
                        <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                      </svg>
                    </i>
                  </a>
                </li>

                <li className="footer__social-item footer__social-item--pinterest">
                  <a href="https://www.pinterest.com/boatint">
                    <i>
                      <FaPinterestP />
                    </i>
                  </a>
                </li>

                <li className="footer__social-item footer__social-item--instagram">
                  <a href="https://www.instagram.com/boatinternational">
                    <i>
                      <FaInstagram />
                    </i>
                  </a>
                </li>

                <li className="footer__social-item footer__social-item--youtube">
                  <a href="https://www.youtube.com/user/boatinternational">
                    <i>
                      <FaYoutube />
                    </i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer__sub-box footer__sub-box--contains-magazine">
            <div className="footer__box-header">Subscribe</div>

            <div className="footer__sub-box-content" ref={outerRef}>
              <Link className="footer__magazines" href="/subscriptions">
                {isIntersecting && (
                  <img
                    src={magazineCover}
                    alt="Boat International issue August-2021"
                    className="footer__ipad-magazine"
                  />
                )}

                {isIntersecting && (
                  <img
                    src={magazineCover}
                    alt="Boat International issue August-2021"
                    className="footer__print-magazine"
                  />
                )}
              </Link>
            </div>
          </div>
        </div>

        <div className="footer__box">
          <div className="footer__box-header footer__box-header--no-border">
            Sign up to our newsletters
          </div>

          <div className="footer__box-content">
            <p className="footer__newsletters-disclaimer">
              Sign up to BOAT International email newsletters to get the latest superyacht news,
              business analysis, exclusive event invitations, and more.
            </p>

            <Link className="button footer__newsletters-button" href="/newsletters">
              Sign up
            </Link>
          </div>

          <a
            className="footer__back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            BACK TO TOP
          </a>
        </div>
      </div>

      <div className="footer__footer">
        <p className="footer__footer-text">Boat International Media Ltd © 2008 - 2026.</p>

        <p className="footer__footer-text">
          Content presented under the "BOAT Presents" logo is an advertising feature and Boat
          International Limited has been paid to include this content.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
